/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Range_Plan_HintInputs */

const en_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See range bucket prices or book a lesson online.`)
};

const es_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta los precios de cubetas o reserva una lección en línea.`)
};

const de_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehen Sie sich die Preise für die Range-Buckets an oder buchen Sie online eine Unterrichtsstunde.`)
};

const zh_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看练习场价格或在线预订课程。`)
};

const ar_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطّلع على أسعار سلال الميدان أو احجز درساً عبر الإنترنت.`)
};

const fr_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultez les prix des seaux de balles ou réservez un cours en ligne.`)
};

const vi_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem giá xô bóng sân tập hoặc đặt bài học trực tuyến.`)
};

const sw_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angalia bei za ndoo za mipira au weka nafasi ya somo mtandaoni.`)
};

const th_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูราคาถังลูกกอล์ฟ หรือจองบทเรียนออนไลน์`)
};

const bs_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pogledajte cijene kanti loptica ili rezervišite lekciju online.`)
};

const ja_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ボールバケットの料金を確認するか、オンラインでレッスンを予約してください。`)
};

const ko_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레인지 볼 버킷 가격을 확인하거나 온라인으로 레슨을 예약하세요.`)
};

const pt_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja os preços dos baldes de bolas ou agende uma aula online.`)
};

const it_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulta i prezzi dei cestini di palline o prenota una lezione online.`)
};

const sv_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se priser för bollhinkar eller boka en lektion online.`)
};

const nl_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk de prijzen voor ballenemmers of boek online een les.`)
};

const da_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se priser på boldkurve eller book en lektion online.`)
};

const nb_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se priser på ballkurver eller bestill en time på nett.`)
};

const fi_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katso pallokorien hinnat tai varaa oppitunti verkossa.`)
};

const pl_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź ceny koszyków piłek lub zarezerwuj lekcję online.`)
};

const ru_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посмотрите цены на корзины мячей или запишитесь на урок онлайн.`)
};

const tr_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top kovası fiyatlarına göz atın veya online ders ayırtın.`)
};

const hi_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रेंज बाल्टी की कीमतें देखें या ऑनलाइन एक सबक बुक करें।`)
};

const id_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat harga ember bola atau pesan pelajaran secara online.`)
};

const ms_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat harga baldi bola atau tempah pelajaran dalam talian.`)
};

const cs_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podívejte se na ceny košíků míčků nebo si zarezervujte lekci online.`)
};

const el_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δείτε τις τιμές για κουβάδες με μπάλες ή κλείστε μάθημα online.`)
};

const he_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צפו במחירי דליי הכדורים או הזמינו שיעור באינטרנט.`)
};

const af_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sien die pryse vir balemmers of bespreek 'n les aanlyn.`)
};

const hu_range_plan_hint = /** @type {(inputs: Range_Plan_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nézze meg a labdakosár-árakat, vagy foglaljon órát online.`)
};

/**
* | output |
* | --- |
* | "See range bucket prices or book a lesson online." |
*
* @param {Range_Plan_HintInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const range_plan_hint = /** @type {((inputs?: Range_Plan_HintInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Range_Plan_HintInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_range_plan_hint(inputs)
	if (locale === "de") return de_range_plan_hint(inputs)
	if (locale === "zh") return zh_range_plan_hint(inputs)
	if (locale === "ar") return ar_range_plan_hint(inputs)
	if (locale === "fr") return fr_range_plan_hint(inputs)
	if (locale === "vi") return vi_range_plan_hint(inputs)
	if (locale === "sw") return sw_range_plan_hint(inputs)
	if (locale === "th") return th_range_plan_hint(inputs)
	if (locale === "bs") return bs_range_plan_hint(inputs)
	if (locale === "ja") return ja_range_plan_hint(inputs)
	if (locale === "ko") return ko_range_plan_hint(inputs)
	if (locale === "pt") return pt_range_plan_hint(inputs)
	if (locale === "it") return it_range_plan_hint(inputs)
	if (locale === "sv") return sv_range_plan_hint(inputs)
	if (locale === "nl") return nl_range_plan_hint(inputs)
	if (locale === "da") return da_range_plan_hint(inputs)
	if (locale === "nb") return nb_range_plan_hint(inputs)
	if (locale === "fi") return fi_range_plan_hint(inputs)
	if (locale === "pl") return pl_range_plan_hint(inputs)
	if (locale === "ru") return ru_range_plan_hint(inputs)
	if (locale === "tr") return tr_range_plan_hint(inputs)
	if (locale === "hi") return hi_range_plan_hint(inputs)
	if (locale === "id") return id_range_plan_hint(inputs)
	if (locale === "ms") return ms_range_plan_hint(inputs)
	if (locale === "cs") return cs_range_plan_hint(inputs)
	if (locale === "el") return el_range_plan_hint(inputs)
	if (locale === "he") return he_range_plan_hint(inputs)
	if (locale === "af") return af_range_plan_hint(inputs)
	if (locale === "hu") return hu_range_plan_hint(inputs)
	return en_range_plan_hint(inputs)
});